import React from 'react'

import { useStyles } from './ButtonsCanvas.styles'
import MyWebComponent from '../Canvas/west'
import { useFormikContext } from 'formik'
import { productDummyData } from '../../../utils/templateCreationConstants'
import { ButtonInCreation } from '../../../modules/storefront/buttonCreation/reducer'

export const ButtonsCanvas: React.FC = () => {
  const { classes } = useStyles()

  const { values } = useFormikContext<ButtonInCreation>()
  const { buttonData } = values

  return (
    <div
      className={classes.canvas}
      data-testid="canvas-button"
      style={{ backgroundColor: buttonData.canvasColor }}
    >
      <div className={classes.cardWrapper}>
        <MyWebComponent
          int-data={JSON.stringify(buttonData)}
          product-details={JSON.stringify(productDummyData)}
        />
      </div>
    </div>
  )
}
